/*
 *     Import
 *     - Libraries
 */
import * as React from 'react'

// import DatePicker from '../../../../common/DatePicker/DatePicker'
import { DateInput } from '../../../../common/DateInput'
import { PlusIcon } from '../../../../../images/icons/Plus/Plus'
import { BinIcon } from '../../../../../images/icons/Bin/Bin'
import { symbol } from '../../../../common/CurrencyFormat'

class ClaimForm extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            claimDetails: [{ date: '', amount: '', description: '' }],
        }
    }

    componentDidUpdate(prevProps: any) {
        const {
            ClaimDetails = [],
        } = this.props
        if (prevProps.ClaimDetails && ClaimDetails.length !== prevProps.ClaimDetails.length) {
            this.setState({
                claimDetails: ClaimDetails,
            })
        }
    }

    /**
     * Dynamic Field group
     * Set the values on component state.
     * After changing it on the component state, call setFieldValue() to set the values on the form
     *
     * @param  {integer} index [row index]
     * @param  {string} value [Text value to be updated]
     * @param  {string} field [Name of the field to be updated]
     */
    handleDynamicChange = (index, value = '', field = '') => {

        const newClaimDetails = this.state.claimDetails.map((client, sidx) => {

            if (index !== sidx) { return client }

            switch (field) {
                case 'date': return { ...client, date: value }
                case 'amount': return { ...client, amount: value }
                case 'description': return { ...client, description: value }
                default: return { ...client }
            }

        })

        this.setState({ claimDetails: newClaimDetails })
        this.props.setFieldValue(newClaimDetails, this.props.name)
    }

    /**
     * Dynamic Field group
     * Input text fields onChange trigger call this function
     * handleDynamicChange() is called to help setting the values on component state.
     *
     * @param  {integer} index [row index]
     */
    handleDynamicValueChange = (index) => (event) => {
        this.handleDynamicChange(index, event.target.value, event.target.name)
    }

    /**
     * Dynamic Field group
     * Handle the Add new row action request
     * After changing it on the component state, call setFieldValue() to set the values on the form
     */
    handleDynamicAdd = () => {
        this.setState({
            claimDetails: this.state.claimDetails.concat([{ date: '', amount: '', description: '' }]),
        })
        this.props.setFieldValue(this.state.claimDetails, this.props.name)
    }

    /**
     * Dynamic Field group
     * Handle the remove row
     * After changing it on the component state, call setFieldValue() to set the values on the form
     *
     * @param  {integer} idx [row index]
     */
    handleDynamicRemove = (index) => () => {
        this.setState({
            claimDetails: this.state.claimDetails.filter((s, sidx) => index !== sidx),
        })
        this.props.setFieldValue(this.state.claimDetails.filter((s, sidx) => index !== sidx), this.props.name)
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange(event: any) {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    /**
     * On calendar date is selected
     */
    calendarChange = (date: any, index: any) => {
        let newDate = new Date(date)
        let newDateyr = newDate.getFullYear()
        let _todayYear = new Date().getFullYear()
        let _datee = `${String(newDate.getDate()).length < 2 ? 0 : ''}${newDate.getDate()}`
        let yr = newDateyr
        if (_todayYear < newDateyr) {
            yr = _todayYear
        }
        let dd = `${_datee}-${newDate.getMonth() < 9 ? '0' : ''}${newDate.getMonth() + 1}-${yr}`

        this.handleDynamicChange(index, dd, 'date')
    }

    handleChange() {
        // Handle change
    }

    render() {

        let removeCustomStyle = { right: '0' }

        return (
            <div className={`quote__form__inner${this.props.extraClass} ${(this.props.show) ? 'active' : ''}`}>

                <div className="quote__form__dynamicGroup">
                    {this.state.claimDetails.map((claimDetails, index) => (
                        <div key={index} className="quote__form__dynamic">

                            <div className="quote__form__group quote__form__group--calendar form__w50">
                                <label>Claim date</label>
                                {/* <DatePicker
                                    placeholder={claimDetails.date ? claimDetails.date : 'Claim date'}
                                    index={index}
                                    onChange={this.calendarChange}
                                    onFocus={this.focusChange}
                                    claim={true}
                                    dateSelected={claimDetails.date}
                                    placeholderIsDate={claimDetails.date ? true : false}
                                    hideYearsOnSelect={false}
                                /> */}
                                <DateInput
                                    maskTypeChange={true}
                                    placeholder={claimDetails.date ? claimDetails.date : 'DD-MM-YYYY'}
                                    index={index}
                                    onChange={(date) => this.calendarChange(date, index)}
                                    onFocus={this.focusChange}
                                    claim={true}
                                    dateSelected={claimDetails.date}
                                    placeholderIsDate={claimDetails.date ? true : false}
                                    showIcon={false}
                                />
                            </div>

                            <div
                                className="quote__form__group form__w50 quote__form__group--claimAmount"
                                data-text={symbol()}
                            >
                                <label>Amount</label>
                                <input
                                    name="amount"
                                    className=""
                                    id="amount"
                                    type="number"
                                    min="0"
                                    placeholder="Amount"
                                    onChange={this.handleDynamicValueChange(index)}
                                    onFocus={this.focusChange}
                                    value={claimDetails.amount}
                                />
                            </div>

                            <div className="quote__form__group form__w100 claim-desc">
                                <label>Description</label>
                                <input
                                    name="description"
                                    id="description"
                                    type="text"
                                    placeholder="Description"
                                    onChange={this.handleDynamicValueChange(index)}
                                    onFocus={this.focusChange}
                                    value={claimDetails.description}
                                />
                            </div>

                            <button
                                type="button"
                                onClick={this.handleDynamicRemove(index)}
                                className="quote__form__dynamic--remove"
                                style={removeCustomStyle}
                            >
                                <BinIcon />
                            </button>
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    onClick={this.handleDynamicAdd}
                    className="quote__form__dynamic--add"
                >
                    <PlusIcon /><span>Add another claim</span><PlusIcon />
                </button>

            </div>
        )
    }
}

export default ClaimForm



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step01/components/ClaimForm.tsx